import base64 from 'base-64';
import utf8 from 'utf8';

export const encodeBase64 = _input => {
  try {
    const bytes = utf8.encode(_input);
    return base64.encode(bytes);
  } catch (err) {
    console.error('error occured during base64 conversion');
    return '';
  }
};

export const decodeBase64 = _input => {
  try {
    return base64.decode(_input);
  } catch (err) {
    console.error('error occured during base64 to string conversion');
    return '';
  }
};
